import React from "react";
import { Link } from "@atlassiansox/microscopekit";
import DynamicTable from "@atlaskit/dynamic-table";
import { parseDateTime, statusLozenge } from "../../utils";
import { Filter } from "./Filter";
import { IsCronosTriggerWargame } from "../../utils/cronos";
var getHead = function (trigger) {
    var head = {
        cells: [
            {
                key: "id",
                content: "ID.",
                isSortable: true
            },
            {
                key: "wargame-plan",
                content: "Wargame Template",
                isSortable: true
            },
            {
                key: "wargame-environment",
                content: "Environment"
            },
            {
                key: "status",
                content: "Status",
                isSortable: true
            },
            {
                key: "updated-at",
                content: "Updated At (mm/dd/yyyy)",
                isSortable: true
            }
        ]
    };
    return head;
};
export var RecentWargamesListView = function (props) {
    var _a, _b;
    var wargames = (_a = props.serviceWargamesData) !== null && _a !== void 0 ? _a : [];
    return (React.createElement("div", null,
        React.createElement("br", null),
        props.isFilterAvailable ? (React.createElement(Filter, { entities: (_b = wargames === null || wargames === void 0 ? void 0 : wargames.sort(function (wargame1, wargame2) {
                return Number(wargame2.id) - Number(wargame1.id);
            })) !== null && _b !== void 0 ? _b : [], fields: {
                id: "Id",
                wargameTemplateName: "Wargame Template",
                status: "Status"
            }, render: function (filteredWargames) { return (React.createElement(RecentWargamesDynamicTable, { wargames: filteredWargames, serviceId: props.serviceId, isLoading: props.isLoading, trigger: props.trigger })); } })) : (React.createElement(RecentWargamesDynamicTable, { wargames: wargames, serviceId: props.serviceId, isLoading: props.isLoading, trigger: props.trigger }))));
};
var RecentWargamesDynamicTable = function (_a) {
    var _b;
    var wargames = _a.wargames, isLoading = _a.isLoading, serviceId = _a.serviceId, trigger = _a.trigger;
    return (React.createElement(DynamicTable, { isLoading: isLoading, caption: "Recent Wargames", head: getHead(trigger), isFixedSize: true, rows: ((_b = wargames === null || wargames === void 0 ? void 0 : wargames.filter(function (wargame) { return IsCronosTriggerWargame(wargame, trigger); }).sort(function (wargame1, wargame2) {
            return Number(wargame2.id) - Number(wargame1.id);
        })) !== null && _b !== void 0 ? _b : []).map(function (wargame) {
            var updatedAt = wargame.updatedAt
                ? parseDateTime(wargame.updatedAt)
                : "";
            return {
                key: "row-" + wargame.id,
                cells: [
                    {
                        key: "wargame-" + wargame.id,
                        content: (React.createElement(Link, { to: "/services/" + encodeURIComponent(serviceId) + "/resilience/ondemand/wargame-details?id=" + wargame.id }, wargame.id))
                    },
                    {
                        key: "wargame-name-" + wargame.wargameTemplateName,
                        content: wargame.wargameTemplateName
                    },
                    {
                        key: "wargame-environment-" + wargame.environment,
                        content: wargame.environment
                    },
                    {
                        key: "wargame-status-" + wargame.status,
                        content: statusLozenge(wargame.status)
                    },
                    {
                        key: "wargame-updated-" + updatedAt,
                        content: updatedAt
                    }
                ]
            };
        }), emptyView: React.createElement("div", null, "No Records Found"), rowsPerPage: 10 }));
};
